module.exports = __webpack_public_path__ + "@/assets/img/server.6299745f.svg";